import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { FlowBaseInfo } from '../../../ts/models/FlowInfo';
import { Flows } from '../../../ts/resources/Flows';
import { DetailsTooltipStyles } from '../CardView/DetailsTooltipStyles';
import { SpacesSiteUrls } from '../SpacesSiteUrls';
import { BasicField } from './Elements/BasicField';
import { MarkupField } from './Elements/MarkupField';
import { Name } from './Elements/Name';
import { Tags } from './Elements/Tags';
import { Tooltip } from './Elements/Tooltip';
import { UpdatedAt } from './Elements/UpdatedAt';
import { User } from './Elements/User';
import { ContentTooltipProps, TooltipDescriptionTestId } from './TooltipHelper';


export function FlowTooltip(props: ContentTooltipProps): JSX.Element {
  const { content, urls } = props;
  const flowInfo = content as FlowBaseInfo;
  return (
    <Tooltip>
      <Name name={content.name} />
      <MarkupField markup={props.content.description}
                  testId={TooltipDescriptionTestId}
                  extraClasses={[DetailsTooltipStyles.MetadataSectionWithContentDescription]} />
      <Tags tags={props.content.tags} />
      <BasicField name={Messages.inputSteps()} value={flowInfo.inputCount} />
      <BasicField name={Messages.outputSteps()} value={flowInfo.outputCount} />
      <User user={props.content.owner} label={Messages.owner()} urls={urls} />
      <UpdatedAt value={props.content.updatedAt} />
    </Tooltip>
  );
}
